import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const TOGGLE = 'DBM/UI/MAIN_MENU/TOGGLE';
const CLOSE = 'DBM/UI/MAIN_MENU/CLOSE';

//
// Create actions
//
const toggle = createAction(TOGGLE);
const close = createAction(CLOSE);


export const actionTypes = {
    TOGGLE,
    CLOSE
};

export const actions = {
    toggle,
    close
};

//
// Export reducer
//
export const reducer = handleActions({
    [system.INIT]: () => (state) => state.setIn(['ui', 'currentMenuVisibility'], false),
    [TOGGLE]: () => (state) => state.setIn(['ui', 'currentMenuVisibility'], !state.getIn(['ui', 'currentMenuVisibility'])),
    [CLOSE]: () => (state) => state.setIn(['ui', 'currentMenuVisibility'], false)
});

const isOpen = (state) => state.getIn(['ui', 'currentMenuVisibility']);

export const selectors = {
    isOpen
};
